import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/PaintGame/scenes/GameIntro';

interface PhaserPaintGameProps {
    onComplete: () => void;

}

interface PhaserPaintGameState {
}

const gameConfig: GameConfig = {
    title: "Painting Game",
    version: "0.9.0",
    backgroundColor: "#000000",
    "render.pixelArt": true
};

class PhaserPaintGame extends React.Component<PhaserPaintGameProps, PhaserPaintGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserPaintGameProps) {
        super(props);
        bindAllOfThis(this, PhaserPaintGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig}  onComplete={this.props.onComplete}/>
        </div>);
    }
}

export default PhaserPaintGame;



// WEBPACK FOOTER //
// ./src/games/PaintGame/Main.tsx